// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hs_cd_list[data-v-22cc56d3] { overflow-y: auto; max-height: 450px;\n}\n/* collapse 표에서는 고정 헤더 윗부분으로 스크롤된 행 글자가 비쳐 보여 separate 로 (셀마다 위·왼쪽 테두리만 있어 모양 동일) */\n.hs_cd_list table[data-v-22cc56d3] { border-collapse: separate; border-spacing: 0;\n}\n.hs_cd_list thead th[data-v-22cc56d3] { position: sticky; top: 0; z-index: 1;\n}\n", ""]);
// Exports
module.exports = exports;
